import React from "react"
import { FaBook, FaUsers, FaSync } from "react-icons/fa"

function CourseLeadFluency() {
  const steps = [
    {
      icon: FaBook,
      number: "1",
      title: "Aprenda o mais importante PRIMEIRO!",
      description: "A língua inglesa possui um vasto vocabulário com mais de 500.000 palavras, no entanto, cerca de 80% das conversas cotidianas dos nativos se baseiam em apenas 2.000 palavras comuns."
    },
    {
      icon: FaUsers,
      number: "2",
      title: "Converse com outras pessoas!",
      description: "A verdadeira fluência só é alcançada através da aplicação prática de tudo o que você está aprendendo. Existem inúmeros grupos de conversação, tanto presenciais quanto online. Totalmente gratuitos!"
    },
    {
      icon: FaSync,
      number: "3",
      title: "Consistência e exposição ao mesmo conteúdo!",
      description: "Aprender coisas novas é fácil, mas esquecê-las é ainda mais fácil! Por isso, é preciso ter bastante exposição ao mesmo conteúdo, de preferência, em contextos diferentes."
    }
  ]

  return (
    <div className="w-full bg-gradient-to-br from-violet-50 to-indigo-50 py-16 md:py-24 lg:py-28">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center text-gray-900 mb-4 md:mb-6 lg:mb-16 px-4">
            Como ficar fluente sem perder tempo?
          </h1>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-6 lg:gap-8">
            {steps.map((step, index) => {
              const Icon = step.icon
              return (
                <div key={index} className="flex flex-col bg-white rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-100">
                  {/* Number and Icon */}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-full bg-violet-600 flex items-center justify-center text-white font-bold text-lg">
                      {step.number}
                    </div>
                    <Icon size={24} className="text-violet-600" />
                  </div>

                  {/* Title */}
                  <h2 className="text-lg md:text-xl font-bold text-gray-900 mb-4 leading-snug">
                    {step.title}
                  </h2>

                  {/* Description */}
                  <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CourseLeadFluency
